export default __webpack_public_path__ + "static/media/roundedborders.a7b2dab9.png";